import { render, staticRenderFns } from "./Wires.vue?vue&type=template&id=36ffd085"
import script from "./Wires.vue?vue&type=script&lang=js"
export * from "./Wires.vue?vue&type=script&lang=js"
import style0 from "./Wires.vue?vue&type=style&index=0&id=36ffd085&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports